module.exports = __webpack_public_path__ + "img/clients3-717.aeda76b.png";